import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import { FormProvider, useForm } from 'react-hook-form'
import FormProperties from './SummaryReferenceFormProperties'
import useCustomYupValidationResolver from '../../../components/aciacehighway/hooks/useCustomYupValidationResolver'
import Grid from '@material-ui/core/Grid'

const {
  button: { CngButton }
} = components

const { initialValues, makeValidationSchema } = FormProperties.formikProps

function SummaryReferenceFieldsPlaceholder(props) {
  const { onAdd, shouldHideMap } = props

  const { translate } = useTranslation(Namespace.N_B_C_I_CANADA_INVOICE)
  const methods = useForm({
    defaultValues: initialValues,
    resolver: useCustomYupValidationResolver(makeValidationSchema(translate))
  })

  const {
    formState: { isDirty }
  } = methods

  return (
    <FormProvider {...methods}>
      <Grid container justify='flex-end' spacing={1}>
        <Grid item xs={12}>
          <FormProperties.Fields shouldHideMap={shouldHideMap} />
        </Grid>
        {isDirty && (
          <Grid item xs='auto'>
            <CngButton onClick={methods.handleSubmit(onAdd)} size='small'>
              Add
            </CngButton>
          </Grid>
        )}
      </Grid>
    </FormProvider>
  )
}

export default SummaryReferenceFieldsPlaceholder
